<template>
  <el-dialog :title="title" :visible="visible" width="1100px" append-to-body :close-on-click-modal="false" :show-close="!busy" :close-on-press-escape="!busy" @close="close">
    <el-alert title="上传后由后台校验并处理，可在任务列表查看完成状态和错误日志；处理完成后点击刷新业务数据。" type="info" :closable="false" />
    <div class="import-actions"><el-button size="small" :disabled="busy" @click="$refs.file.click()">选择文件</el-button><span>{{ file ? file.name : '支持 XLS / XLSX，最大 10MB' }}</span><input ref="file" type="file" accept=".xls,.xlsx" hidden @change="selectFile"><el-button size="small" type="primary" :loading="busy" :disabled="!file" @click="submit">上传</el-button><el-button size="small" @click="refresh">刷新任务及业务数据</el-button></div>
    <el-alert v-if="error" :title="error" type="error" :closable="false" />
    <div style="height:400px"><import-task ref="tasks" class="import-task" /></div>
    <span slot="footer"><el-button :disabled="busy" @click="close">关闭</el-button></span>
  </el-dialog>
</template>
<script>
import { errorText, buildImportTask, responseData } from '../model'
export default {
  props: { visible: Boolean, title: String, reportName: { type: String, required: true }, appCode: { type: String, default: 'ec-pc-api' }, paramMap: { type: Object, default: () => ({}) } },
  data () { return { file: null, busy: false, error: '' } },
  mounted () { this.$nextTick(this.refresh) },
  methods: {
    close () { if (!this.busy) this.$emit('update:visible', false) },
    selectFile (event) {
      const file = event.target.files[0]
      this.error = ''; this.file = null
      if (file && !/\.xlsx?$/i.test(file.name)) this.error = '请选择 .xls 或 .xlsx 文件'
      else if (file && file.size > 10 * 1024 * 1024) this.error = '文件大小不能超过 10MB'
      else this.file = file
      event.target.value = ''
    },
    refresh () { if (this.$refs.tasks) this.$refs.tasks.init({ reportName: this.reportName, appCode: this.appCode, startDate: '', endDate: '' }); this.$emit('refresh') },
    async submit () {
      if (!this.file || this.busy) return
      this.busy = true; this.error = ''
      try { responseData(await this.$q.common.uploadFile({ data: { file: this.file, taskDTO: JSON.stringify(buildImportTask(this.reportName, this.appCode, this.paramMap)) } })); this.file = null; this.$message.success('导入任务已提交，请查看处理结果'); this.refresh() } catch (error) { this.error = errorText(error) } finally { this.busy = false }
    }
  }
}
</script>
<style>
.import-actions{display:flex;align-items:center;gap:12px;margin:16px 0}
.import-actions span{color:#909399}
.v-modal {
  z-index: 999 !important;
}
</style>
